import React from "react"
import { useState, useEffect } from "react"
import i18n from 'i18n/index.js'

function HomeCover({ covers, home_collection }) {
  const [cover, setCover] = useState({})
  let guide_image = "https://viewnia-static.s3.us-east-2.amazonaws.com/especialista.png";

  useEffect(() => {
    try {
      const coverData = typeof covers === "string" ? JSON.parse(covers) : covers
      setCover(coverData)
    } catch (error) {
      console.error("Error parsing covers JSON: ", error)
      setCover({})
    }
  }, [covers])

  return (
    <section className="hero-cover-simple">
      <div className="slide-info py-0 my-0">
        <div className="text-content my-5">
          <div className="title-cover-simple" aria-hidden="true">
            <strong>{home_collection?.name || 'Título por defecto'}</strong><br />
            {home_collection?.subtitle || 'Subtítulo por defecto'}
          </div>
        </div>
        <div className="chat-widget">
          <div className="chat-avatar">
            <img src={guide_image} alt="Especialista" />
          </div>
          <div className="chat-content">
            <p className="chat-question">{i18n.t('chat.need_help')}</p>
            <a
              href="https://api.whatsapp.com/send?phone=56981785011"
              className="chat-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p className="chat-answer">
                {i18n.t('chat.talk_to_local_guide')}
              </p>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HomeCover
